import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'
import styles from './ApplicationStudioApp.module.scss'

const ApplicationStudioApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    const studio = apps[AppId.APPLICATION_STUDIO]

    const appProps = {
      user,
      initialPath: location.pathname,
      appPath: studio?.path ?? '/application-studio',
      history,
      onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
        const { pathname } = location

        if (pathname !== nextPathname) {
          navigate(nextPathname)
        }
      }
    }

    return (
      <FullPageAppTemplate
        appId={AppId.APPLICATION_STUDIO}
        scope='application_studio'
        envKey={studio?.runtimeEnvKey}
        entryPath='./ApplicationStudioApp'
        url={process.env.REACT_APP_APPLICATION_STUDIO_APP_DEV_PATH}
        appName={studio?.name ?? 'Application Studio'}
        appProps={appProps}
        className={styles.wrapper}
      />
    )
  },
  () => true
)

export { ApplicationStudioApp }
